import addToCartSuccessMessageHtml from "./addToCartSuccessMessage.html";

export default (quantity) => /* html */ `
<div class="amount-in-cart">
  <div class="amount">
    ${addToCartSuccessMessageHtml(quantity)}
  </div>
  <a href="/viewcart.cfm" class="">
    <button class="btn btn-primary">
      <i class="icon-shopping-cart"></i> View Cart</button>
  </a>
  <a href="/shipping-billinginfo.cfm" class>
    <button class="btn btn-orange">
      <i class="icon-lock"></i> Checkout</button>
  </a>
</div>`;
